// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"c410da91","319":"d34c83a2","347":"c1d939d5","547":"d503f1d5","766":"57c0385d","787":"1fef002d","883":"3fb8eef8"}[chunkId] + ".chunk.js";
};